import { Block } from "../../styles/basicStyles";
import { FC } from "react";
import { useTranslation } from "next-i18next";
import Typography from "../../components/typography";
// import Lottie from 'react-lottie';
// import animationData from '../../../public/assets/no_records_animation.json'

interface Props {
  text: string;
}

const NoRecords: FC<Props> = ({ text }) => {
  const { t } = useTranslation();

  // const defaultOptions = {
  //   loop: true,
  //   autoplay: true, 
  //   animationData: animationData,
  //   rendererSettings: {
  //     preserveAspectRatio: 'xMidYMid slice'
  //   }
  // };

  return (
    <Block tAlign='center' margin={{ md: '6 0', xxs: '4 0' }}>
      {/* <Block maxW={30} margin='auto'>
        <Lottie 
          options={defaultOptions}
        />
      </Block> */}
      <Typography 
        as='div' 
        fSize={1.2} 
        lHeight={2} 
        maxW={65} 
        margin='auto'
        padding='0 2'
        dangerouslySetInnerHTML={{ __html: t(text) }}
      />
    </Block>
  );
};

export default NoRecords;
